import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ValueProp from './components/ValueProp';
import Login from './components/Login';
import Faq from './components/Faq';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

const ButtonFactoryLogin = ({ handleLogin, handleSignUp }) => {
  useEffect(() => {
    trackEventWithData(FPTI_SPEC.LANDING_PAGE_IM);
  }, []);

  return (
    <div className="login-container">
      <Login handleLogin={handleLogin} handleSignUp={handleSignUp} />
      <ValueProp />
      <Faq />
    </div>
  );
};

ButtonFactoryLogin.propTypes = {
  handleLogin: PropTypes.func,
  handleSignUp: PropTypes.func,
};
export default ButtonFactoryLogin;
